document.addEventListener('DOMContentLoaded', () => {
  let footnotes = [];
  document.querySelectorAll('.footnote-container').forEach((elem) => {
    let id_prefix = elem.getAttribute('id') ? elem.getAttribute('id') + '-' : '';
    let containted_footnotes = []
    elem.querySelectorAll('[data-wf-footnote]').forEach((fn) => {
      let fn_text = fn.getAttribute('data-wf-footnote');
      let already_added = true;
      if (!footnotes.includes(fn_text)) {
        footnotes.push(fn_text);
        already_added = false;
      }
      let fn_ind = footnotes.indexOf(fn_text) + 1;
      if(!already_added) {
        containted_footnotes.push(footnotes.indexOf(fn_text));
      }
      fn.innerHTML = `<a href='#${id_prefix}fn-${fn_ind}'>${fn_ind}</a>`
    })
    elem.querySelector('.footnote-display').innerHTML = containted_footnotes.map((i) => `<div class='footnote' id='${id_prefix}fn-${i+1}'><sup class='footnote-index'>${i+1}</sup> ${footnotes[i]}</div>`).join('');
  })
});